import { Children, Fragment, ReactNode } from 'react';

import { Divider, Stack } from '@cast/design-system';

type ChartMetricsRowProps = {
  alignItems?: 'stretch' | 'center' | 'flex-start' | 'flex-end';
  alwaysRow?: boolean;
  children: ReactNode;
  gap?: number;
  testId?: string;
};

export const ChartMetricsRow = ({
  alignItems = 'stretch',
  alwaysRow = false,
  children,
  gap = 12,
  testId,
}: ChartMetricsRowProps) => {
  const items = Children.toArray(children);

  return (
    <Stack
      direction={alwaysRow ? 'row' : { none: 'column', laptop: 'row' }}
      alignItems={alignItems}
      gap={gap}
      data-testid={testId}
      sx={{ '& > *:not(.MuiDivider-root)': { flex: 1, minWidth: 0 } }}
    >
      {items.map((child, index) => (
        <Fragment key={index}>
          {index > 0 ? (
            <Divider
              flexItem
              orientation="vertical"
              sx={
                alwaysRow
                  ? undefined
                  : { display: { none: 'none', laptop: 'block' } }
              }
            />
          ) : null}
          {child}
        </Fragment>
      ))}
    </Stack>
  );
};
